{% block sw_cms_block_acris_blog_product_slider %}
    <div class="sw-cms-block-acris-blog-product-slider">
        <slot name="column"></slot>
    </div>
{% endblock %}
